import { FilterOption, filterRegistry } from "./filterRegistry";
import Grid from '@mui/material/Grid';
import './genericFilters.css';
import GenricMultiSelect from "../Input/GenericMultiSelect";
import { useEffect, useRef, useState } from "react";
import { ChannelkartNetworkGet } from "../../services/networkService";
import { isArray } from "lodash";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { clearGenericFilter, updateGenericFilter } from "../../stateManagement/actions/genericFilterActions";
import { genericFilterType } from "../../stateManagement/reducers/genericFilterReducer";
import { resetLocationData } from "../../stateManagement/actions/locationDataActions";
import { usePortalTranslation } from "../../providers/TranslationProvider";
import store from "../../stateManagement/store";

const CUR_COMPONENT_COMMON="commonPortal";
export interface GenericFilterOptions{
    multiLine?: boolean;
    id: string;
    label?: string;
    parent:string;
    api: string;
    apiWithFilter?:string;
    options?:string[]
    preSelectedOption?:string;
    inputType?:string;
    filterConfig:{
        filterKey:string
        filterOperator:string
    }
    type?: string;
    multiSelect?: boolean;
    fetchId?: string
}
interface GenericFilterProps{
    filterOptions:GenericFilterOptions[],
    onApplyClick?:()=>any;
    resetFiltersFlag?: boolean,
    preSelectedData?: {
        [key: string]: string
    }
    CUR_COMPONENT?:string
    hideResetButton?: boolean
}

const GenericFilters = (props:GenericFilterProps)=>{
    const {translate} = usePortalTranslation();
    const [filterOptions, setFilterOptions] = useState<FilterOption[]>([]);
    const [resetFlag, setResetFlag] = useState<boolean>(false);
    const isFirstRender = useRef(true);

    useEffect(()=>{
        clearGenericFilter();
        const filterList :FilterOption[]= props.filterOptions.map(filterObject=>{
            const registryObject = filterRegistry.find(object=>object.id === filterObject.id);
            if(registryObject && props.preSelectedData && props.preSelectedData[registryObject.id]){
                return {...registryObject,...filterObject,"preSelectedOption":props.preSelectedData[registryObject.id]}
            }
            return registryObject ? {...registryObject,...filterObject} : {...filterObject};
        }).filter(Boolean) as FilterOption[];
        setFilterOptions(filterList);
    },[resetFlag])

    const addFilterToApi = (api:string, apiType:string, parentFilterOptions:GenericFilterOptions,selectedOptions: string[] | string)=>{
        if((selectedOptions && isArray(selectedOptions) && selectedOptions.length === 0)||(!selectedOptions)){
            return "";
        }
        if(apiType === "API"){
            const selectedData = isArray(selectedOptions) ? ('[' + selectedOptions + ']') : selectedOptions;
            let filter:string = "";
            if(parentFilterOptions.filterConfig){
                filter = filter + parentFilterOptions.filterConfig.filterKey + (isArray(selectedOptions) ? "[in]:" : ":") + selectedData;
            }else{
                filter = filter + parentFilterOptions.id + (isArray(selectedOptions) ? "[in]:" : ":") + selectedData;
            }
            return api + "?size=5000&filter=" + filter;
        }else if(apiType === "QUERY"){
            let filter:string = "";
            if(parentFilterOptions.filterConfig){
                filter = filter + parentFilterOptions.filterConfig.filterKey + "=" + selectedOptions;
            }else{
                filter = filter + parentFilterOptions.id + "=" + selectedOptions;
            }
            return api + "&" + filter;
        }
        return ""
    }

    const handleFilterChange = (selectedOptions: string[] | string,updatedFilterOption: GenericFilterOptions)=>{
        const updatedFilterOptionArray = [...filterOptions]
        const updatedFilters:genericFilterType= {};
        updatedFilters[updatedFilterOption.id] = selectedOptions;
        updatedFilterOptionArray.forEach((option:FilterOption)=>{
            if(option.parent === updatedFilterOption.id){
                // updatedFilters[option.id] = "";
                option.apiWithFilter = addFilterToApi(option.api,option.apiType,updatedFilterOption,selectedOptions)
            }
        })
        updateGenericFilter(updatedFilters);
        setFilterOptions(updatedFilterOptionArray)
    }
    const resetFilters = ()=>{
        setResetFlag(!resetFlag);
        clearGenericFilter();
    }
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        resetFilters();
    },[props.resetFiltersFlag])
    
    return (
        <>
            <Grid container spacing={2}>
                {filterOptions.map(filterObject=>{
                    if(filterObject.inputType && filterObject.inputType === "textField"){
                        return (
                            <Grid item xs={12} key={filterObject.id}>
                                <GenericFilterTextInput resetFlag={resetFlag} filterOption={filterObject} handleFilterChange={handleFilterChange} CUR_COMPONENT={props.CUR_COMPONENT ? props.CUR_COMPONENT : "Generic Filters"}/>
                            </Grid>
                        );
                    }else if((!filterObject.inputType || filterObject.inputType === "selectField")){
                        return (
                            <Grid item xs={4} key={filterObject.id}>
                                <GenericFilterSelectInput resetFlag={resetFlag} filterOption={filterObject} handleFilterChange={handleFilterChange} CUR_COMPONENT={props.CUR_COMPONENT? props.CUR_COMPONENT : "Generic Filters"}/>
                            </Grid>
                        );
                    }
                })}
            </Grid>
            { (props.onApplyClick || !props.hideResetButton) && <div className="filter-button-container">
                {props.onApplyClick &&
                    <button className="filter-apply-button" onClick={props.onApplyClick}> {translate(CUR_COMPONENT_COMMON,"APPLY")}</button>
                }
                {!props.hideResetButton && <button className="filter-reset-button" onClick={resetFilters}> {translate(CUR_COMPONENT_COMMON,"RESET")} </button>}
            </div>}
            
        </>

    );
}


const GenericFilterTextInput = (props:GenericFilterInputProps)=>{
  const {translate} = usePortalTranslation();
  const [inputValue, setInputValue] = useState(props.filterOption.preSelectedOption ?? "");
  const isFirstRender = useRef(true);

  useEffect(()=>{
    if (isFirstRender.current) {
        isFirstRender.current = false;
        if(props.filterOption.preSelectedOption){
            props.handleFilterChange(props.filterOption.preSelectedOption, props.filterOption);
        }
        return;
    }
    setInputValue('');
  },[props.resetFlag]);
  
  const handleInputChange = (event:any) => {
    props.handleFilterChange(event.target.value, props.filterOption);
    setInputValue(event.target.value);
  };
  
  return (
    <TextField
      label={translate(props.CUR_COMPONENT as string,props.filterOption.label as string) ?? translate(props.CUR_COMPONENT as string,props.filterOption.id as string)}
      value={inputValue}
      onChange={handleInputChange}
      multiline={props.filterOption.multiLine === true}
      inputProps={
        props.filterOption.multiLine === true
          ? {
              style: {
                maxHeight: '4.2em',
                overflow: 'scroll',
              },
            }
          : undefined
      }
    />
  );
}

interface GenericFilterInputProps {
    filterOption:GenericFilterOptions,
    resetFlag: boolean,
    handleFilterChange:(selectedOptions : string[] | string, filterOptions:GenericFilterOptions)=>void
    CUR_COMPONENT?:string;
}

const GenericFilterSelectInput = (props:GenericFilterInputProps)=>{
    const {translate} = usePortalTranslation();
    let preSelectedOptions:string[] = []
    if(props.filterOption.preSelectedOption){
        if(props.filterOption.preSelectedOption.includes(",")){
            preSelectedOptions = props.filterOption.preSelectedOption.split(",")
        }else{
            preSelectedOptions =[props.filterOption.preSelectedOption]
        }
    }
    const [options, setOptions] = useState<any>([]);
    const [selectedOptions, setSelectedOptions] = useState<string[]>(preSelectedOptions);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const isFirstRender = useRef(true);

    useEffect(()=>{
        if(preSelectedOptions.length){
            if(props.filterOption.multiSelect){
                props.handleFilterChange(preSelectedOptions.length ? preSelectedOptions : "",props.filterOption)
            }else{
                props.handleFilterChange(preSelectedOptions.length ? preSelectedOptions[0] : "",props.filterOption)
            }
        }
    },[])

    useEffect(()=>{
        const fetchOptions = async ()=>{
            let filterResponse;
            if(props.filterOption.options){
                filterResponse = {
                    data:{
                        features:props.filterOption.options.map(option=>({[props.filterOption.id]:option}))
                    }
                }
                setIsLoading(false);
            }else if(props.filterOption.apiWithFilter){
                setIsLoading(true)
                filterResponse = await ChannelkartNetworkGet(props.filterOption.apiWithFilter);
                setIsLoading(false);
            }else if(!props.filterOption.parent){
                setIsLoading(true)
                filterResponse = await ChannelkartNetworkGet(props.filterOption.api);
                setIsLoading(false)
            }else{
                setOptions([]);
                setSelectedOptions([]);
                setIsLoading(false)
                return;
            }
            saveFetchedDataIfNecessary(filterResponse)
            const dataArrayToMap = filterResponse.data.features ?? filterResponse.data; 
            const fetchedOptions: string[] = dataArrayToMap.map((data: any) => data[props.filterOption.fetchId ?? props.filterOption.id]).filter(Boolean).filter((value: string, index: number, array: string[]) => array.indexOf(value) === index);
            setOptions(fetchedOptions);
            const newSeletedOptions = selectedOptions.filter(option=>fetchedOptions.includes(option));
            setSelectedOptions(newSeletedOptions);
            const genericFilterData = store?.getState()?.genericFilter;
            // console.log("genericFilterData",genericFilterData,props.filterOption.id,newSeletedOptions)
            if (genericFilterData.hasOwnProperty(props.filterOption.id)) {
                genericFilterData[props.filterOption.id] = newSeletedOptions;
            } 
            updateGenericFilter(genericFilterData)
        }
        fetchOptions();
    },[props.filterOption.apiWithFilter])

    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setSelectedOptions([]);
    },[props.resetFlag]);

    const saveFetchedDataIfNecessary = (filterResponse:any)=>{
        if(props.filterOption.id === "branch" || props.filterOption.id === "district"){
            const locationData:{[key:string]:string} = {};
            filterResponse?.data?.features.forEach((featureData:{id:string, [key:string]:string})=>{
                if(locationData[featureData[props.filterOption.id]]){
                    locationData[featureData[props.filterOption.id]] += ","+featureData.id;
                }else{
                    locationData[featureData[props.filterOption.id]] = featureData.id;
                }
            })

            resetLocationData(locationData);
        }
    }

    const handleMultiSelectState = (selectedOptions: string[])=>{
        setSelectedOptions(selectedOptions)
        props.handleFilterChange(selectedOptions.length ? selectedOptions : "",props.filterOption)
    }
    const handleSelectState = (event:any, value:any)=>{
        
        setSelectedOptions([value])
        props.handleFilterChange(value,props.filterOption)
    }
    return (
        <>
        {isLoading && 
            <GenricMultiSelect 
                params={{disabled:true}}
                label={translate(props.CUR_COMPONENT as string,props.filterOption.label as string) ?? translate(props.CUR_COMPONENT as string,props.filterOption.id as string)} 
                options={options}
                selectedOptions={selectedOptions}
                handleMultiSelectState = {handleMultiSelectState}
                isRequired = {false}
                noOptionMessage = "No Data" 
            />
        }
        {!isLoading && props.filterOption.multiSelect && 
            <GenricMultiSelect 
                label={translate(props.CUR_COMPONENT as string,props.filterOption.label as string) ?? translate(props.CUR_COMPONENT as string,props.filterOption.id as string)} 
                options={options}
                selectedOptions={selectedOptions}
                handleMultiSelectState = {handleMultiSelectState}
                isRequired = {false}
                noOptionMessage = "No Data" 
            />
        }
        {!isLoading && !props.filterOption.multiSelect && 
            <Autocomplete
                disablePortal
                options={options}
                onChange={handleSelectState}
                value={selectedOptions[0] ?? ""}
                renderInput={(params) => <TextField {...params} label={translate(props.CUR_COMPONENT as string,props.filterOption.label as string) ?? translate(props.CUR_COMPONENT as string,props.filterOption.id)}  />}
            />
        }
        </>
    );
}

export default GenericFilters